import dynamic from "next/dynamic";
import React, { CSSProperties } from "react";
import { ProductFaq } from "../../../../../../graphql/operations";
import { CloudinaryImage } from "../../../../../Atoms/Cloudinary";
import ToggleContentItem from "../../../../../Cards/ToggleSection/ToggleContentItem";
import styles from "./styles.module.scss";
const Markdown = dynamic(() => import("react-markdown"), { ssr: false });

type Props = {
  faq: ProductFaq;
  withBorder?: boolean;
  style?: CSSProperties;
};

const FAQItem: React.FC<Props> = ({ faq, withBorder, style }) => {
  return (
    <ToggleContentItem
      title={faq.question}
      className={styles.Item}
      withBorder={withBorder}
      style={style}
    >
      <Markdown
        components={{
          p: ({ node, ...props }) => (
            <p className={styles.MarkdownParagraph} {...props} />
          ),
          a: ({ node, ...props }) => (
            <a
              className={styles.MarkdownLink}
              target="_blank"
              rel="noopener noreferrer"
              {...props}
            />
          ),
        }}
      >
        {faq.answer}
      </Markdown>
      {faq.imageUrl && (
        <div className={styles["Image"]}>
          <CloudinaryImage src={faq.imageUrl} />
        </div>
      )}
    </ToggleContentItem>
  );
};

export default FAQItem;
